<template>
  <div
    class="viewcontent"
    v-if="translations.buttons && translations.memory && translations.errors"
  >
    <form class="row mx-3" @submit.prevent="processGenerateMemory()">
      <div class="col-sm-6 col-xs-12">
        <label for="title" class="form-label w-100 my-3">
          {{ translations.memory.form_title }}
          <input
            type="text"
            id="title"
            name="title"
            class="form-control"
            v-model="data.title"
          />
        </label>
        <label for="subtitle" class="form-label w-100 my-3">
          {{ translations.memory.form_subtitle }}

          <input
            type="text"
            id="subtitle"
            name="subtitle"
            class="form-control"
            v-model="data.subtitle"
          />
        </label>
        <label class="form-check-label w-100 my-2 form-check " for="events">
          {{ translations.memory.form_events }}

          <div
            class="listcont"
            v-if="
              usertype == 2 &&
                memoryevents.historical &&
                memoryevents.historical.length > 0
            "
          >
            <div
              class="form-check-label"
              v-for="(item, index) in memoryevents.historical"
              :key="index"
              name="events"
            >
              <label>
                <input
                  class="form-check-input icon"
                  type="checkbox"
                  :value="item.id"
                  v-model="data.selectedEvents"
                />
                {{ defineTitle(item.title) }}
              </label>
            </div>
          </div>
          <Alert type="warning" :message="translations.errors.memory_events" v-else/>
        </label>
      </div>
      <div class="col-sm-6 col-xs-12">
        <div
          class="form-check switch form-switch form-switch-md mt-5 mb-5 w-100 text-start"
        >
          <input
            class="form-check-input"
            type="checkbox"
            id="debug"
            @click="changeCheck('debug')"
            :checked="data.debug == 1 ? true : false"
          />
          <label class="form-check-label w-100 my-2" for="debug">
            {{ translations.memory.form_debug }}
          </label>
        </div>

        <div
          class="form-check switch form-switch form-switch-md mb-5 mt-5 w-100 text-start"
        >
          <input
            class="form-check-input"
            type="checkbox"
            id="subscriber_statistics"
            @click="changeCheck('subscriber_statistics')"
            :checked="data.subscriber_statistics == 1 ? true : false"
          />
          <label
            class="form-check-label w-100 my-2"
            for="subscriber_statistics"
          >
            {{ translations.memory.form_subscriber_statistics }}
          </label>
        </div>
        <label class="form-check-label w-100 my-2 form-check " for="chapters">
          {{ translations.memory.form_chapters }}

          <div class="listcont">
            <div
              class="form-check-label"
              v-for="(item, index) in chapters"
              :key="index"
              name="chapters"
            >
              <label>
                <input
                  class="form-check-input icon"
                  type="checkbox"
                  :value="item.id"
                  v-model="data.selectedChapters"
                />
                {{ item.title }}
              </label>
            </div>
          </div>
        </label>
      </div>
      <div class="col-12 pt-2">
        <button class="btn btn-danger mx-2" type="button" @click="cancel()">
          {{ translations.buttons.btn_exit }}
        </button>

        <input
          class="btn btn-primary mx-2"
          type="submit"
          :value="translations.buttons.btn_memory"
        />
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'
  export default {
    name: 'ToolGenerateMemory',
    components: {
      Alert,
    },
    data() {
      return {
        data: {
          title: '',
          subtitle: '',
          subscriber_statistics: true,
          debug: false,
          selectedChapters: [
            'equipments',
            'ods',
            'programs',
            'statistics',
            'budget',
          ],
          selectedEvents: [],
        },
        chapters: [
          { title: 'Equipaments', id: 'equipments' },
          { title: 'ODS', id: 'ods' },
          { title: 'Programes', id: 'programs' },
          { title: 'Estadístiques', id: 'statistics' },
          { title: 'Pressupost', id: 'budget' },
        ],
      }
    },
    computed: {
      ...mapState([
        'memoryevents',
        'usertype',
        'languageSelected',
        'front',
        'translations',
        'user',
      ]),
    },
    methods: {
      ...mapActions(['getMemoryEvents', 'changeToolSelected', 'getUser']),
      processGenerateMemory() {
        if (this.usertype == 2) {
          let ls = JSON.parse(localStorage.getItem('token'))

          let url =
            this.front +
            '/resume/index.php?events=' +
            this.data.selectedEvents +
            '&action=generatememory&token=' +
            ls.token +
            '&chapters=' +
            this.data.selectedChapters
          if (this.data.debug) {
            url += '&debug=' + this.data.debug
          }
          if (this.data.subscriber_statistics) {
            url += '&subscriber_statistics=' + this.data.subscriber_statistics
          }
          if (this.data.title) {
            url += '&title=' + this.data.title
          }
          if (this.data.subtitle) {
            url += '&subtitle=' + this.data.subtitle
          }
          if (this.user.style) {
            url += '&style=' + this.user.style
          }
          // window.location.href = url
          window.open(url, '_blank')
        }
      },
      changeCheck(value) {
        switch (value) {
          case 'subscriber_statistics':
            this.data.subscriber_statistics =
              this.data.subscriber_statistics == 0 ? 1 : 0

            break
          case 'debug':
            this.data.debug = this.data.debug == 0 ? 1 : 0

            break
        }
      },
      cancel() {
        this.changeToolSelected(null)
      },
      defineTitle(title) {
        let text = ''

        if (title) {
          let result = title.find((x) => x.key === this.languageSelected)
          text = result && result.text ? result.text : title[0].text
        }

        return text
      },
      defineTitleDefault() {
        if (this.data.title == '' && this.translations.memory) {
          this.data.title =
            this.translations.memory.title_default +
            ' ' +
            new Date().getFullYear()
        }
      },
    },
    created() {
      this.getMemoryEvents()
      this.defineTitleDefault()
      this.getUser()
    },
  }
</script>

<style scoped>
  .form-check .form-check-input {
    padding-left: initial;
  }
  .form-check .item {
    text-align: left;
    /* padding-left: 1.5rem; */
  }
  .listcont {
    text-align: left;
  }
  .form-switch.form-switch-md {
    margin-bottom: 1rem; /* JUST FOR STYLING PURPOSE */
  }

  .form-switch.form-switch-md .form-check-input {
    height: 1.5rem;
    margin-right: 5px;

    width: calc(2rem + 0.75rem);
    border-radius: 3rem;
  }
  .switch {
    position: relative;
  }
  .switch .form-check-label {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: contents;
  }
  .switch .form-check-input {
    margin-top: 0;
  }
</style>
